import { useState } from "react";

import { warehouselocationBinusage } from "../../services/warehouseService";

export const useWarehouseBinUsage = () => {

    const [binUsage, setBinusage] = useState([]);

    const checkWarehouseBinUsage = async (locationid) => {
        const para = { p_location_id: locationid };

        try {
            const data = await warehouselocationBinusage(para);           
            setBinusage(data || []);
            return data || []; // 🔥 return fetched data directly
        } catch (error) {
            alert(error.message);
        }
    };

    return {
        binUsage,
        checkWarehouseBinUsage,
        setBinusage,   // optional – if you need reset
    };
};
